import React from 'react';
import { Text, View, ScrollView, Pressable, Image, StyleSheet } from 'react-native';

import { ParticipantAvatar, NavBar, I18n, OPComponent } from '../components';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { connect } from 'react-redux';

import { getCurrentCaseParticipants } from '../cases/selector';

class Assignment extends OPComponent {
  static navigatorStyle = NavBar && NavBar.navigatorStyle;

  constructor(props) {
    super(props);

    this.state = {
      assigneeUserId: props.selectedAssigneeUserId || null,
    };
  }

  handleSelect = (assignee) => {
    const assigneeUserId = assignee.userId;
    this.setState({ assigneeUserId });
    this.props.onSelect(assigneeUserId);
  };

  removeAssignee = () => {
    this.setState({ assigneeUserId: null });
    this.props.onSelect(null);
  };

  renderParticipantView = (item, index) => {
    return (
      <View style={styles.itemContainer} key={`${item.participant.userId}`}>
        <ParticipantAvatar
          participant={item}
          circleStyles={styles.avatarSize}
          onPress={this.handleSelect}
          showNameLabel={true}
        />
      </View>
    );
  };

  _findAssignee() {
    const { participants } = this.props;
    const { assigneeUserId } = this.state;
    let assignee = null;
    for (let i = 0; i < participants.length; i++) {
      const item = participants[i];
      if (item.participant.userId === assigneeUserId) {
        return item;
        break;
      }
    }
  }

  render() {
    const { participants } = this.props;
    const selectedAssignee = this._findAssignee();

    return (
      <View style={styles.container}>
        <View style={styles.header}>
          <Text style={styles.headerText}>{I18n.t('calendar.assignmentInstructions')}</Text>
        </View>

        <View style={styles.subHeader}>
          <Text style={styles.subHeaderLabel}>{I18n.allCaps('calendar.assignedTo')}</Text>
        </View>

        {!!selectedAssignee ? (
          <View style={styles.assigneeContainer}>
            <ParticipantAvatar participant={selectedAssignee} circleStyles={styles.avatarSize} />
            <Text style={styles.assigneeNameText}>
              {selectedAssignee.profile && selectedAssignee.profile.fullName}
            </Text>

            <Pressable style={styles.closeButton} onPress={this.removeAssignee}>
              <Image
                style={styles.closeIcon}
                source={require('../../../resources/close-orange.png')}
              />
            </Pressable>
          </View>
        ) : (
          <View style={styles.assigneeContainer}>
            <View style={styles.avatarPlaceholder} />
            <Text style={styles.assigneeNameText}>{I18n.capitalizeFirst('calendar.noOne')}</Text>
          </View>
        )}

        <View style={{ flex: 1 }}>
          <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={styles.participantsContainer}
            onScroll={this.handleScroll}
            scrollEventThrottle={8}
          >
            {participants.map(this.renderParticipantView)}
          </ScrollView>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: THEME.container,
  header: {
    backgroundColor: COLOR.altContrast,
    paddingVertical: 30,
    paddingHorizontal: 25,
    borderColor: COLOR.accent,
    borderTopWidth: 1,
  },
  headerText: {
    ...FONT.medium,
    fontSize: FONT_SIZE.regular,
    color: COLOR.text,
  },
  participantsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 15,
    backgroundColor: COLOR.altContrast,
  },
  itemContainer: {
    margin: 10,
  },
  avatarSize: {
    width: 50,
    height: 50,
  },
  subHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    borderColor: COLOR.accent,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    paddingVertical: 20,
    paddingHorizontal: 25,
  },
  subHeaderLabel: {
    ...FONT.medium,
    fontSize: FONT_SIZE.large,
    color: COLOR.text,
    marginRight: 20,
  },
  assigneeContainer: {
    paddingVertical: 15,
    paddingHorizontal: 25,
    flexDirection: 'row',
    alignItems: 'center',
  },
  avatarPlaceholder: {
    width: 50,
    height: 50,
    margin: 5,
    borderColor: COLOR.textLight,
    borderWidth: 2,
    borderRadius: 25,
    borderStyle: 'dashed',
  },
  assigneeNameText: {
    flex: 1,
    ...FONT.semibold,
    fontSize: FONT_SIZE.xlarge,
    color: COLOR.textLight,
    marginLeft: 15,
  },
  closeIcon: {
    width: 24,
    height: 24,
  },
  closeButton: {
    padding: 15,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    participants: getCurrentCaseParticipants(state),
    followers: state.entities.followers,
  };
}

export default connect(mapStateToProps)(Assignment);
